module.exports = __webpack_public_path__ + "static/OP7-5ccd231020c604a82fb9436f92b9edb5.png";